import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path, Circle } from '../IconBase/IconBase'

const TowService = ({ color = 'icon.primary', strokeWidth = 2, ...props }) => (
  <IconBase viewBox='0 0 41 24' {...props}>
    <Path
      d='M14.8809 23.7074H28.6685'
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='transparent'
    />
    <Circle
      cx='31.0949'
      cy='23.7082'
      r='2.42691'
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='transparent'
    />
    <Circle
      cx='12.4543'
      cy='23.7082'
      r='2.42691'
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='transparent'
    />
    <Path
      d='M27.8594 5.10156V15.3931C27.8594 15.8399 27.4972 16.2021 27.0504
         16.2021H6.82617V22.0899C6.82617 22.9835 7.55055 23.7078 8.44411 23.7078H10.0269'
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='transparent'
    />
    <Path
      d='M27.8574 5.10156H33.1102C34.8129 5.10156 36.3334 6.16794 36.9132
         7.76893L38.9896 13.5014C39.1175 13.8547 39.183 14.2276 39.183 14.6034V21.2809C39.183
          22.6213 38.0964 23.7078 36.7561 23.7078H33.5202'
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='transparent'
    />
    <Path
      d='M39.183 14.8132H34.3292L33.1851 13.6692C32.8817 13.3658 32.4702 13.1953 32.0411 13.1953H27.8574'
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='transparent'
    />
    <Path
      d='M27.587 2V16H7.49979L1.5 18'
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='transparent'
    />
    <Path
      d='M9.5 1.5L27 12.5M9.5 1.5V7.5M9.5 1.5L23 16'
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='transparent'
    />
    <Path
      d='M9.5 11.5C10.0304 11.5 10.5391 11.2893 10.9142 10.9142C11.2893 10.5391
         11.5 10.0304 11.5 9.5C11.5 8.96957 11.2893 8.46086 10.9142 8.08579C10.5391
          7.71071 10.0304 7.5 9.5 7.5'
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      fill='transparent'
    />
  </IconBase>
)

TowService.propTypes = {
  color: PropTypes.string,
  strokeWidth: PropTypes.number,
}

export default TowService
